module.exports = __webpack_public_path__ + "img/uuundulate_profil.df141ae7.svg";